import { Input } from "@/components/ui/input";
import { SearchableSelect } from "@/components/shared/SearchableSelect";
import { useAssetOptions } from "./useAssetOptions";

export function FilterBar({ dateFrom, dateTo, assetId, onChange, testIdPrefix }) {
  const assetOptions = useAssetOptions();

  return (
    <div className="flex flex-wrap items-end gap-3">
      <div>
        <p className="text-xs text-slate-500 mb-1">From</p>
        <Input
          type="date"
          value={dateFrom || ""}
          onChange={(e) => onChange({ dateFrom: e.target.value })}
          data-testid={`${testIdPrefix}-date-from`}
          className="w-40"
        />
      </div>
      <div>
        <p className="text-xs text-slate-500 mb-1">To</p>
        <Input
          type="date"
          value={dateTo || ""}
          onChange={(e) => onChange({ dateTo: e.target.value })}
          data-testid={`${testIdPrefix}-date-to`}
          className="w-40"
        />
      </div>
      <div>
        <p className="text-xs text-slate-500 mb-1">Machine</p>
        <SearchableSelect testId={`${testIdPrefix}-asset-filter`} className="w-52" value={assetId || "all"} onValueChange={(v) => onChange({ assetId: v === "all" ? "" : v })} placeholder="All machines"
  options={[{ value: "all", label: "All machines", pinned: true }, ...assetOptions.map((o) => ({ value: o.value, label: o.label }))]} />
      </div>
    </div>
  );
}
